import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {OmgIndicator} from "../../profile-box-messages-indicator/indicators/omg-indicator.component";
import {FreePlayIndicatorComponent} from "../../profile-box-messages-indicator/indicators/freeplay-indicator.component";
import {LoyaltyBar} from "../../loyalty-bar/loyalty-bar.component";
import {UserDetails} from "../../user-details/user-details.component";
import {observer} from "mobx-react";
import {UsefulLinks} from "../../useful-links/useful-links.component";
import {UserBalance} from "../../balance-box/user-balance.component";
import {UserMenuItemsContainerComponent} from "../user-menu-items/user-menu-items-container.component";
import {MiniControlCenterComponent} from "../mini-control-center/mini-control-center.component";
import {UserMenuScrollWrapperBox} from "./boxes/user-menu-scroll-wrapper.box";
import { ProfileMessagesBox } from "../../profile-box/boxes/profile-box-messages/profile-messages.box";
import {UserMenuFakeIOSPaddingBox} from "./boxes/user-menu-fake-ios-padding.box";
import {UserMenuFooter} from "../../user-menu-footer/user-menu-footer.component";
import {FlexContainerBox, FlexFixedSizeItemBox, FlexGrowItemBox} from "../../../themes/architecture/css-helpers/flex";

export const UserMenuMobile = observer(class UserMenuMobile extends OrbitComponent {
  render() {
    // NB: the PC layout has the profile-box-messages, loyalty bar, and
    // dynamics boxes in the SideMenu, whereas the mobile layout has them
    // here in the pop-out menu.

    return (
      <UserMenuScrollWrapperBox>
        <FlexContainerBox direction="column" style={{height: "100%"}}>
          <FlexGrowItemBox>
            <UserDetails />
            <UserBalance />
            <ProfileMessagesBox className="cy-profile-box-messages">
              <OmgIndicator />
              <FreePlayIndicatorComponent />
            </ProfileMessagesBox>
            <LoyaltyBar />
            <UserMenuItemsContainerComponent />
            <MiniControlCenterComponent/>

            <UsefulLinks />
          </FlexGrowItemBox>
          <FlexFixedSizeItemBox>
            <UserMenuFooter />
          </FlexFixedSizeItemBox>
        </FlexContainerBox>
        {this.services.device.os.isIOS && <UserMenuFakeIOSPaddingBox />}
      </UserMenuScrollWrapperBox>
    );
  }
});
